import { environment } from '../../environments/environment';

/**
 * 获取当前环境类型
 * @returns 'production' 或 'development'
 */
export function getCurrentEnv(): 'production' | 'development' {
  return environment.production ? 'production' : 'development';
}

/**
 * 获取当前区域
 * @returns 区域字符串，如 'com', 'cn', 'international'
 */
export function getCurrentRegion(): string {
  return environment.region;
}

/**
 * 检查是否为生产环境
 * @returns boolean
 */
export function isProduction(): boolean {
  return environment.production;
}

/**
 * 检查是否为开发环境
 * @returns boolean
 */
export function isDevelopment(): boolean {
  return !environment.production;
}
